import React, {useEffect} from 'react';
import {useI18nContext} from "../../contexts/I18nContext";
import {useStyles} from "./ShopProducts.style";
import Box from "../../ui_components/Box/Box";
import Width from "../../ui_components/common/enums/Width";
import Alignment from "../../ui_components/common/enums/Alignment";
import FilterInput from "../../shared_components/Inputs/FilterInput/FilterInput";
import Button from "../../ui_components/Button/Button";
import {Observer} from "mobx-react-lite";
import ShowPagination from "../../ui_components/ShowPagination/ShowPagination";
import MessageCard from "../../ui_components/MessageCard/MessageCard";
import FastfoodIcon from '@mui/icons-material/Fastfood';
import {useCommonContext} from "../../contexts/CommonContext";
import ButtonType from "../../ui_components/Button/ButtonType";
import ShopProductStore from './ShopProductStore';
import ShopProductRow from './ShopProductRow/ShopProductRow';
import NewShopProductButton from '../../shared_components/Buttons/NewShopProductButton/NewShopProductButton';
import AllowAccess from '../../shared_components/Access/AllowAccess/AllowAccess';
import Access from '../../shared_components/Access/AllowAccess/Access';

const ShopProducts: React.FC = () => {
    const commonStore = useCommonContext();
    const i18n = useI18nContext();
    const shopProductStore = new ShopProductStore(commonStore);
    const classes = useStyles();

    useEffect(() => {
        shopProductStore.getElements();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onUpdate = async () => {
        await shopProductStore.getElements();
    }

    const onPaginationChange = async (page: number, pageSize: number) => {
        await shopProductStore.goToPage(page, pageSize);
    }


    return (
        <Observer>
            {() => (
                <div className={classes.shop_products_container}>
                    <Box className={classes.tools_container}
                         width={Width.FULL_WIDTH}
                         justifyContent={Alignment.END}
                    >
                        {/* <ShowShopProductCostsButton type={ButtonType.SECONDARY}/> */}
                        <div></div>
                        <AllowAccess any={[Access.CREATE_SHOP_PRODUCT]}>
                            <NewShopProductButton type={ButtonType.SECONDARY} onSave={onUpdate}/>
                        </AllowAccess>
                    </Box>
                    <Box className={classes.filter_container} width={Width.FULL_WIDTH}
                         justifyContent={Alignment.SPACE_BETWEEN}>
                        <FilterInput value={shopProductStore.filter}
                                     placeholder={i18n.translate("ARTICLE_FILTER_PLACEHOLDER")}
                                     onChange={(value) => {
                                        shopProductStore.setFilter(value)
                                     }} onEnter={() => shopProductStore.search()}/>
                        <Button
                            onClick={() => {
                                shopProductStore.search()
                            }}
                            className={classes.search_btn}
                            text={i18n.translate("SEARCH")}
                        />
                    </Box>
                    {!shopProductStore.isEmpty &&
                    <div className={classes.shop_products_table}>
                        <ShowPagination onChange={onPaginationChange}
                                        elementLabel={'Productos'}
                                        pagination={shopProductStore.pagination}/>
                        <div className={classes.elements_container}>
                            {shopProductStore.shopProducts.map((shopProduct, i) => (
                                <ShopProductRow
                                    onUpdate={onUpdate}
                                    shopProduct={shopProduct} key={i}
                                />
                            ))}
                        </div>
                        <ShowPagination
                            onChange={onPaginationChange}
                            elementLabel={'Productos'}
                            pagination={shopProductStore.pagination}/>
                    </div>}
                    {shopProductStore.isEmpty &&
                    <MessageCard icon={FastfoodIcon} title={i18n.translate("NO_SHOP_PRODUCTS_TITLE")}
                                 subtitle={i18n.translate("NO_SHOP_PRODUCTS_SUBTITLE")}/>}
                </div>
            )}
        </Observer>
    )
}

export default ShopProducts;
